import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class GoogleTagManager implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_GOOGLE_TAG_MANAGER;
  label: string = 'Google Tag Manager';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = false;

  getClientIdRegexp(): RegExp {
    return /^GTM-[0-9a-z]+$/i;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
